"use strict";

document.addEventListener("DOMContentLoaded", () => {
  var adpPopup = {};

  (function () {
    var $this;

    adpPopup = {
      sPrevious: window.scrollY,
      sDirection: "down",
      eventsBound: false,

      init: function () {
        $this = adpPopup;
        $this.popupInit();
        $this.setupEvents();
      },

      // Bind global listeners once (section reloads in the theme editor call init again)
      setupEvents: function () {
        if ($this.eventsBound) return;
        $this.eventsBound = true;
        document.addEventListener("click", $this.handleButtonClick);
        document.addEventListener("keyup", $this.handleKeyPress);
        document.addEventListener("click", $this.handleOverlayClick);
        document.addEventListener("scroll", $this.updateScrollDirection, { passive: true });
      },

      popupInit: function () {
        document.querySelectorAll(".popup").forEach($this.setupPopup);
      },

      updateScrollDirection: function () {
        const scrollCurrent = window.scrollY;
        $this.sDirection = scrollCurrent > $this.sPrevious ? "down" : "up";
        $this.sPrevious = scrollCurrent;
      },

      setupPopup: function (popup) {
        const id = popup.dataset.id;

        // Visitor just subscribed (page reloaded after the form post)
        const success = popup.querySelector(".newsletter-form__message--success");
        if (success) {
          $this.setCookie("popup-subscribed-" + id, 1, {
            expires: popup.dataset.limitNewsletterLifetime || 365
          });

          // Show the thank-you message only if this popup's form was the one submitted
          // (the footer form redirects with its own #hash)
          const form = popup.querySelector("form");
          const hash = window.location.hash.slice(1);
          if (!hash || (form && hash === form.id)) {
            $this.openPopup(popup);
          }
          return;
        }

        if (!$this.isAllowPopup(popup)) return;
        $this.openTriggerPopup(popup);
      },

      handleButtonClick: function (e) {
        const target = e.target;
        const popup = target.closest(".popup");
        if (!popup) return;

        if (target.closest(".popup-close")) {
          $this.closePopup(popup, true);
        }
        if (target.closest(".popup-accept")) {
          $this.acceptPopup(popup);
          $this.closePopup(popup, true);
        }
      },

      handleKeyPress: function (e) {
        if (e.key === "Escape") $this.closePopupsByAttribute("data-esc-close");
        if (e.key === "F4") $this.closePopupsByAttribute("data-f4-close");
      },

      handleOverlayClick: function (e) {
        if (e.target.classList.contains("popup-overlay")) {
          $this.closePopupsByAttribute("data-overlay-close");
        }
      },

      closePopupsByAttribute: function (attribute) {
        document
          .querySelectorAll(`.popup-open[${attribute}="true"]`)
          .forEach((popup) => $this.closePopup(popup, true));
      },

      isAllowPopup: function (popup) {
        const id = popup.dataset.id;

        // Disabled on mobile
        if (popup.dataset.mobileDisable === "true" && window.matchMedia("(max-width: 749px)").matches) {
          return false;
        }

        // Already subscribed
        if ($this.getCookie("popup-subscribed-" + id)) return false;

        // Visitor closed it themselves (999 kept for visitors who have the old cookie)
        const count = parseInt($this.getCookie("popup-" + id) || 0, 10);
        if ($this.getCookie("popup-closed-" + id) || count >= 999) return false;

        // Display count limit (0 = no limit)
        const limitDisplay = parseInt(popup.dataset.limitDisplay || 0, 10);
        return !(limitDisplay && count >= limitDisplay);
      },

      openTriggerPopup: function (popup) {
        const trigger = popup.dataset.openTrigger;

        if (trigger === "delay") {
          const delay = parseFloat(popup.dataset.openDelayNumber) || 0;
          setTimeout(() => $this.openPopup(popup), delay * 1000);
        }

        if (trigger === "exit") {
          const exitHandler = function (e) {
            if (e.clientY < 7) {
              $this.openPopup(popup);
              document.removeEventListener("mousemove", exitHandler);
            }
          };
          document.addEventListener("mousemove", exitHandler);
        }

        if (trigger === "scroll") {
          const scrollType = popup.dataset.openScrollType;
          const scrollPos = parseFloat(popup.dataset.openScrollPosition) || 0;

          const scrollHandler = () => {
            const reached = scrollType === "px"
              ? window.scrollY >= scrollPos
              : $this.getScrollPercent() >= scrollPos;

            if (reached) {
              $this.openPopup(popup);
              document.removeEventListener("scroll", scrollHandler);
            }
          };

          document.addEventListener("scroll", scrollHandler, { passive: true });
          scrollHandler(); // page may already be scrolled or too short to scroll
        }
      },

      closeTriggerPopup: function (popup) {
        const trigger = popup.dataset.closeTrigger;

        if (trigger === "delay") {
          const delay = parseFloat(popup.dataset.closeDelayNumber) || 0;
          setTimeout(() => $this.closePopup(popup, false), delay * 1000);
        }

        if (trigger === "scroll") {
          const type = popup.dataset.closeScrollType;
          const pos = parseFloat(popup.dataset.closeScrollPosition) || 0;
          const initPx = parseFloat(popup.dataset.initScrollPx) || 0;
          const initPercent = parseFloat(popup.dataset.initScrollPercent) || 0;

          const scrollHandler = () => {
            const up = $this.sDirection === "up";
            const down = $this.sDirection === "down";
            const px = window.scrollY;
            const pc = $this.getScrollPercent();

            const shouldClose =
              (type === "px" && up && px < initPx - pos) ||
              (type === "px" && down && px >= initPx + pos) ||
              (type === "%" && up && pc < initPercent - pos) ||
              (type === "%" && down && pc >= initPercent + pos);

            if (shouldClose) {
              $this.closePopup(popup, false);
              document.removeEventListener("scroll", scrollHandler);
            }
          };

          document.addEventListener("scroll", scrollHandler, { passive: true });
        }
      },

      openPopup: function (popup) {
        if (popup.classList.contains("popup-open") || popup.classList.contains("popup-already-opened")) return;

        if (popup.dataset.bodyScrollDisable === "true") {
          document.body.classList.add("popup-scroll-hidden");
        }

        // Count this view
        const id = popup.dataset.id;
        const count = parseInt($this.getCookie("popup-" + id) || 0, 10) + 1;
        $this.setCookie("popup-" + id, count, { expires: popup.dataset.limitLifetime || 30 });

        popup.classList.add("popup-open");
        popup.dataset.initScrollPx = window.scrollY;
        popup.dataset.initScrollPercent = $this.getScrollPercent();

        $this.applyAnimation(popup, popup.dataset.openAnimation);
        $this.closeTriggerPopup(popup);

        // Move focus into the dialog for keyboard and screen-reader users
        const focusTarget = popup.querySelector("input, button");
        if (focusTarget) setTimeout(() => focusTarget.focus({ preventScroll: true }), 50);
      },

      // byUser = true when the visitor closed it (button, ESC, F4, overlay);
      // false when it closed itself (delay or scroll setting)
      closePopup: function (popup, byUser) {
        if (!popup || !popup.classList.contains("popup-open")) return;

        $this.applyAnimation(popup, popup.dataset.exitAnimation, function () {
          popup.classList.add("popup-already-opened");
          popup.classList.remove("popup-open");
          document.body.classList.remove("popup-scroll-hidden");

          if (byUser) {
            $this.setCookie("popup-closed-" + popup.dataset.id, 1, {
              expires: popup.dataset.limitLifetime || 30
            });
          }
        });
      },

      acceptPopup: function (popup) {
        $this.setCookie("popup-accept-" + popup.dataset.id, 1, { expires: 360 });
      },

      applyAnimation: function (popup, name, callback) {
        const animEvents = ["webkitAnimationEnd", "animationend"];
        const isExit = typeof callback === "function";

        // Overlay: use the next ELEMENT, and only if it really is the overlay
        const next = popup.nextElementSibling;
        const overlay = next && next.classList.contains("popup-overlay") ? next : null;
        const overlayAnim = isExit ? "popupExitFade" : "popupOpenFade";

        if (overlay) {
          overlay.classList.add("popup-animated", overlayAnim);
          animEvents.forEach((ev) =>
            overlay.addEventListener(ev, () => overlay.classList.remove("popup-animated", overlayAnim), { once: true })
          );
        }

        const wrap = popup.querySelector(".popup-wrap");
        let finished = false;
        const finish = () => {
          if (finished) return;
          finished = true;
          if (wrap && name) wrap.classList.remove("popup-animated", name);
          if (isExit) callback();
        };

        if (wrap && name) {
          wrap.classList.add("popup-animated", name);
          animEvents.forEach((ev) => wrap.addEventListener(ev, finish, { once: true }));
          // Fallback: never leave the popup stuck if the animation doesn't fire
          setTimeout(finish, 1200);
        } else {
          finish();
        }
      },

      getCookie: function (name) {
        const match = document.cookie.match(new RegExp(
          "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"
        ));
        return match ? decodeURIComponent(match[1]) : undefined;
      },

      setCookie: function (name, value, options) {
        options = Object.assign({ path: "/", SameSite: "Lax" }, options || {});

        // Data attributes arrive as strings ("30"), so convert days to a real date
        if (options.expires !== undefined && !(options.expires instanceof Date)) {
          const days = parseFloat(options.expires);
          if (isNaN(days)) {
            delete options.expires;
          } else {
            options.expires = new Date(Date.now() + days * 864e5).toUTCString();
          }
        }

        let updated = `${name}=${encodeURIComponent(value)}`;
        for (const [prop, val] of Object.entries(options)) {
          updated += val === true ? `; ${prop}` : `; ${prop}=${val}`;
        }
        document.cookie = updated;
      },

      getScrollPercent: function () {
        const h = document.documentElement;
        const b = document.body;
        const max = (h.scrollHeight || b.scrollHeight) - h.clientHeight;
        if (max <= 0) return 100; // page too short to scroll
        return ((h.scrollTop || b.scrollTop) / max) * 100;
      }
    };
  })();

  adpPopup.init();
  document.addEventListener("shopify:section:load", adpPopup.init);
  document.addEventListener("shopify:section:unload", () =>
    document.body.classList.remove("popup-scroll-hidden")
  );
});